// src/hooks/useLogin.js
import { useState, useRef } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export function useLogin() {
    const { login } = useAuth();
    const isSubmittingRef = useRef(false);

    // Estados del formulario
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [token2FA, setToken2FA] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    // Estados de control de flujo
    const [requires2FA, setRequires2FA] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Evitamos doble-clic accidental
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;

        setError('');
        setLoading(true);

        try {
            const payload = {
                email: typeof email === 'string' ? email.trim() : '',
                password: typeof password === 'string' ? password : '',
                ...(requires2FA && { token2FA: typeof token2FA === 'string' ? token2FA.trim() : '' })
            };

            const rawRes = await api.post('/auth/login', payload);
            const responseData = rawRes?.data ?? rawRes;

            // Interceptamos si el backend exige el segundo factor (2FA)
            if (responseData?.requires2FA) {
                setRequires2FA(true);
                isSubmittingRef.current = false;
                return;
            }

            const usuarioAutenticado = responseData?.data?.user ?? responseData?.user;

            if (!usuarioAutenticado) {
                throw new Error('Login autorizado pero el servidor no devolvió el perfil de usuario.');
            }

            // Guardamos sesión globalmente
            login(usuarioAutenticado);

        } catch (err) {
            console.error('====== 🚨 ERROR LOGIN 🚨 ======', err);
            let mensajeError = 'Error de comunicación con el servidor.';

            if (err.response?.data) {
                mensajeError = typeof err.response.data.message === 'string'
                    ? err.response.data.message
                    : JSON.stringify(err.response.data.message);
            } else if (err.message) {
                mensajeError = err.message;
            }

            setError(mensajeError);
        } finally {
            // 🛡️ FIX B3: reseteamos SIEMPRE el candado, también en éxito. Antes solo
            // se limpiaba en 2FA/error; era una bomba de relojería si el login pasa
            // a ser un modal reutilizable (el segundo submit quedaría bloqueado).
            isSubmittingRef.current = false;
            setLoading(false);
        }
    };

    return {
        email, setEmail,
        password, setPassword,
        token2FA, setToken2FA,
        showPassword, setShowPassword,
        requires2FA, loading, error,
        handleSubmit
    };
}